import React from 'react'
import {
  Description,
  ImageContainer,
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import {
  ActionElementType,
  changeLevels,
} from 'Components/SharedComponents/Surveys/constants'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import { UserActions } from 'Components/SharedComponents/Surveys/UserActions/UserActions'
import {
  ButtonAction,
  CustomAction,
} from 'Components/SharedComponents/Surveys/types'
import { CheckInSurveyEvent } from 'Modules/Analytics/trackActionInterface/Surveys/checkIn'
import { HandleActionArgs, HandleFireAnalytics } from '../types'
import { CheckInWizardStep } from '../constants'
import { CheckInSurveyStepper } from './CheckInSurveyStepper'

type YourOrgHealthProps = {
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  onChangeOrgHealth: (value: string) => void
  onChangeOrgHealthChange: (value: string) => void
  onFireAnalytics: HandleFireAnalytics
  orgHealthChange: string
  orgHealthChangeExplanation: string
}

export const YourOrgHealth = ({
  onAnyAction,
  onChangeOrgHealth,
  onChangeOrgHealthChange,
  onFireAnalytics,
  orgHealthChange,
  orgHealthChangeExplanation,
}: YourOrgHealthProps) => {
  const nextActions: ButtonAction[] = [
    {
      callback: () => onFireAnalytics(CheckInSurveyEvent.Survey_Completed),
      label: 'Submit',
      disabled: orgHealthChange === '',
      path: CheckInWizardStep.THANK_YOU,
      saveUserState: true,
      type: ActionElementType.BUTTON,
    },
  ]
  const userActions: CustomAction[] = [
    {
      callback: (...args: unknown[]) => onChangeOrgHealth(args[0] as string),
      label: "How has your organization's health changed?",
      options: changeLevels,
      required: true,
      type: ActionElementType.SELECT,
      value: orgHealthChange,
    },
    {
      callback: (...args: unknown[]) =>
        onChangeOrgHealthChange(args[0] as string),
      label: 'Please explain your choice',
      type: ActionElementType.TEXT_FIELD,
      value: orgHealthChangeExplanation,
    },
  ]

  return (
    <StepContainer>
      <CheckInSurveyStepper step={2} />
      <Title>About your organizational health</Title>
      <Description>
        Last time we asked you about the amount of support that your
        organization needed in order to strengthen its capacity.
      </Description>
      <ImageContainer>{/* <Image src={getStarted} /> */}</ImageContainer>
      <UserActions onAnyAction={onAnyAction} userActions={userActions} />
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
